module.exports = __webpack_public_path__ + "img/77.cd153fe1.jpg";